// A job's outputs as the row actions and the saves name them (issue 238): by job and index, as
// sibling jobs (a talking head's actors) each have an output 0.
import type { GenerationOutput, Job } from "../../api/generated/model";
import { isSettled } from "./status";

/** One output of a row, named by its job and its index there. */
export interface OutputPick {
  jobId: string;
  index: number;
}

/** A row's output as a key: sibling jobs each have an output 0. */
export function outputKey(pick: OutputPick): string {
  return `${pick.jobId}:${pick.index}`;
}

/** The outputs delivered with their file still at hand: what the row's actions act on. */
export function deliveredOutputs(job: Job): GenerationOutput[] {
  return job.outputs.filter((output) => output.status === "delivered" && output.url !== null);
}

/**
 * The outputs a job's views show (G13): every one but those settled `unused`, which a Layerize
 * keeps room for and does not make (no failure, never shown). A Layerize still running shows one
 * waiting output, as live's one card, rather than its 17 slots.
 */
export function shownOutputs(job: Job): GenerationOutput[] {
  if (job.type === "image.layerize" && !isSettled(job.status)) return job.outputs.slice(0, 1);
  return job.outputs.filter((output) => output.error?.code !== "unused");
}
